module.exports = __webpack_public_path__ + "static/media/corner-3.7df03b54.png";